module.exports = __webpack_public_path__ + "assets/img/visitrecord-emtry.bf64dc03.png";